const GCS_BASE_URL = 'https://storage.cloud.google.com'

export const GCS_BUCKET = {
  importDataTemplate: `${GCS_BASE_URL}/c4m-${
    import.meta.env.VITE_ENV
  }-cdp-import-data-template`,
}
